module.exports = __webpack_public_path__ + "img/c2-2_m.3f92ef6e.png";